// GModalContext.ts
import type { InitialValuesType, ModalType } from '../types';

import { createContext, useContext } from 'react';

export interface GModalContextProps<T extends ModalType> {
  modalType: T | null;
  isOpen: boolean;
  isLoading: boolean;
  initialValues: InitialValuesType<T> | null;
  handlers: { [key in T]?: any };
  onSetLoading: (loading: boolean) => void;
  onOpenModal: (type: T, initialValues?: InitialValuesType<T>) => void;
  onSetInitialValues: (value: InitialValuesType<T>) => void;
  onCloseModal: () => void;
  onSetHandler: (type: T, handler: any) => void;
}

export const GModalContext = createContext<GModalContextProps<ModalType> | undefined>(undefined);

export const useGModalContext = <T extends ModalType>(): GModalContextProps<T> => {
  const context = useContext(GModalContext as React.Context<GModalContextProps<T> | undefined>);
  if (!context) {
    throw new Error('useGModalContext must be used within a GModalProvider');
  }
  return context;
};
